import { State, NAMESPACE } from './types';

type GlobalState = {
    [key in typeof NAMESPACE]: State;
};

export const getHeaderCampaigns = (state: GlobalState) =>
    state[NAMESPACE].campaigns;
